export default {
      id: "icon-wet-grip-usage",
      viewBox: "0 0 212 212",
      url: "/" + "sprite.svg#icon-wet-grip",
      toString: function () {
        return this.url;
      }
    }